<template>
  <div class="left_block course-preview-page my-courses">
    <p class="header">
      <router-link :to="'/all-courses'">
        <span> Все курсы <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>

      <router-link :to="'/course-info/' + courseId">
        <span> {{ courseInfo.name }}<i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>

      Предварительный просмотр курса
    </p>

    <CoursePreview v-if="!isLoading" :course-info="courseInfo" :stages-list="stagesList" />

    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
  </div>
</template>

<script>
import CoursePreview from '@/components/admin/all-courses/CoursePreview'

export default {
  components: {
    CoursePreview
  },
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    this.loadData()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === this.$route.name) {
      next()
      if (to.params.id !== from.params.id) {
        this.loadData()
      }
    }
  },
  computed: {
    stagesList() {
      return this.$store.state.courses.stagesList
    },
    courseInfo() {
      return this.$store.state.courses.coursePageInfo
    },
    courseId() {
      return Number(this.$route.params.id)
    },
    branchInfo() {
      return this.$store.state.branches.branchInfo
    },
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    userRole() {
      return this.$store.state.auth.role[0]
    }
  },
  methods: {
    loadData() {
      this.isLoading = true
      this.$axios2
        .get('courses/' + this.courseId)
        .then((resp) => {
          this.$store.commit('setCoursePageInfo', { list: resp.data })
        })
        .catch(this.$errorToast)

      this.$axios2
        .get('courses/' + this.courseId + '/stages')
        .then((resp) => {
          this.$store.commit('setStagesList', { list: resp.data })
          this.isLoading = false
        })
        .catch((err) => {
          this.$errorToast(err)
          this.isLoading = false
        })
    }
  }
}
</script>
